var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { background: "transparent", border: "none" } },
    [
      _c(
        "w-card-title",
        {
          style: {
            padding: "15px 15px 0 15px",
            borderBottom: "none",
            fontWeight: "bold",
            fontSize: "14px",
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("components.chat-components.threads-title")) +
              " "
          ),
        ]
      ),
      _c(
        "w-card-content",
        {
          style: { overflow: "hidden", paddingTop: "5px" },
          attrs: { "no-padding": "" },
        },
        [
          _c(
            "w-list-item",
            { attrs: { to: "/chat/threads" } },
            [
              _c(
                "w-list-item-text",
                [
                  _c("div", { staticClass: "unread" }, [
                    _vm._v(" " + _vm._s(_vm.state.totalThreads) + " "),
                  ]),
                  _c("w-fa", { attrs: { icon: "inbox" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("components.chat-components.inbox")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }